import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { catchError, Observable, throwError } from 'rxjs';

import { mpsRouteNames } from '../mps-route-names';
import { MpsMaintenanceService } from '../services/mps-maintenance.service';

@Injectable()
export class MpsMaintenanceInterceptor implements HttpInterceptor {
  private router = inject(Router);
  private dialogRef = inject(MatDialog);
  private maintenanceService = inject(MpsMaintenanceService);

  intercept(req: HttpRequest<unknown>, handler: HttpHandler): Observable<HttpEvent<unknown>> {
    return handler.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 503) {
          const retryAfter = parseInt(error.headers.get('Retry-After') ?? '0', 10);
          this.maintenanceService.retryAfterSeconds = retryAfter;
          this.maintenanceService.isInMaintenance = true;
          this.dialogRef.closeAll();
          this.router.navigate([mpsRouteNames.maintenance]);
        }

        return throwError(() => error);
      })
    );
  }
}
